// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';
import { outerHeight } from '../classes/Helpers';

export default class HorizontalSliderButton extends Component {
  #direction: string = '';
  #slider: string = '';
  activeClass: string = 'xl:block';
  sliderItemHeight: number;
  offset: number = 0;

  /**
   * Initialize the component.
   *
   * @param el
   */
  bind(el: HTMLElement): void {
    super.bind(el);
    this.setUp();

    const clickHandler: function = this.handleClick.bind(this);
    this.addEventListener(EventNames.CLICK, clickHandler);

    this.addListener(Notifications.SHOW_LEFT_SLIDER_BUTTON, this.showLeftSliderButton);
    this.addListener(Notifications.SHOW_RIGHT_SLIDER_BUTTON, this.showRightSliderButton);
    this.addListener(Notifications.HIDE_LEFT_SLIDER_BUTTON, this.hideLeftSliderButton);
    this.addListener(Notifications.HIDE_RIGHT_SLIDER_BUTTON, this.hideRightSliderButton);
    this.addListener(Notifications.UPDATE_HORIZONTAL_SLIDER_BUTTON_HEIGHT, this.updateSliderItemHeight);
  }

  /**
   * Validation and setup of properties.
   */
  setUp(): void {
    this.#direction = this.el.dataset.direction;
    this.#slider = this.el.dataset.sliderId;

    if (!this.#direction || !this.#slider) {
      throw new Error('All data attributes are required');
    }

    if (this.el.dataset.activeClass) {
      this.activeClass = this.el.dataset.activeClass;
    }
  }

  /**
   * Executes when a button is clicked.
   *
   * @param e
   */
  handleClick(e: MouseEvent): void {
    e.preventDefault();
    this.notify(Notifications.SLIDE, { slider: this.#slider, direction: this.#direction });
  }

  /**
   * Executes when it receives a listener that says the button is allowed to be visible.
   */
  onShow(data: Object): void {
    if (this.#slider !== data.slider) return;
    this.el.classList.add(this.activeClass);
  }

  /**
   * adds the active class to the left slider button
   */
  showLeftSliderButton(data: Object) {
    if (this.#slider !== data.slider) return;
    if (this.el.dataset.direction === 'left') {
      this.el.classList.add(this.activeClass);
    }
    this.updateSliderButtonHeight();
  }

  /**
   * adds the active class to the right slider button
   */
  showRightSliderButton(data: Object) {
    if (this.#slider !== data.slider) return;
    if (this.el.dataset.direction === 'right') {
      this.el.classList.add(this.activeClass);
    }
    this.updateSliderButtonHeight();
  }

  /**
   * removes the active class to the left slider button
   */
  hideLeftSliderButton(data: Object) {
    if (this.#slider !== data.slider) return;
    if (this.el.dataset.direction === 'left') {
      this.el.classList.remove(this.activeClass);
    }
  }

  /**
   * removes the active class to the right slider button
   */
  hideRightSliderButton(data: Object) {
    if (this.#slider !== data.slider) return;
    if (this.el.dataset.direction === 'right') {
      this.el.classList.remove(this.activeClass);
    }
  }

  /**
   *
   */
  updateSliderButtonHeight(): void {
    if (!this.sliderItemHeight) return;
    this.el.style.top = `${(this.sliderItemHeight / 2) - (outerHeight(this.el) / 2) + this.offset}px`;
  }

  /**
   *
   */
  updateSliderItemHeight({ sliderId, itemHeight, offset }: Object): void {
    if (sliderId === this.#slider) {
      this.offset = offset || 0;
      this.sliderItemHeight = itemHeight;
      this.updateSliderButtonHeight();
    }
  }
}
